import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Tree } from 'primereact/tree';

import { findSectionInTree } from '@utils/general';


const DEFAULT_SECTION_DOCUMENT = 10

class CategorieSectionDocumentTree extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: {
        isVisible: false,
        title: '',
        children: null,
        textOk: '',
        textHide: '',
        actionOk: null,
        actionHide: () => {},
      },
      navegationTreeList: [],
      selectedNavegationTree: '',
      selectedLabelNavegationTree: '',
    };
  }

  componentDidMount() {
    const { categoriesSectionCatalog, value, onChangeCategorie, notSelectDocument, allowedSecciones } = this.props;
    const getDocumentsSections = findSectionInTree(DEFAULT_SECTION_DOCUMENT, categoriesSectionCatalog)
    if (getDocumentsSections) {
      let cloneDocumentSections = {...getDocumentsSections}
      cloneDocumentSections.parentKey = 0
      if (notSelectDocument) {
        cloneDocumentSections.selectable = false
      }
      cloneDocumentSections = [ cloneDocumentSections ]
  
      if (allowedSecciones?.navega === "ALL") {
        cloneDocumentSections.push({
          "id": 1,
          "nombre": {
              "es": "Home"
          },
          "label": "Home",
          "key": 1,
          parentKey: 0
        })
      }
  
    const x = {
      "id": 0,
      "nombre": {
          "es": "./"
      },
      "label": "./",
      "selectable": false,
      "key": 0,
      children: cloneDocumentSections
  }
      // getDocumentsSections = categoriesSectionCatalog[0].children[4] // Section Dummy
      this.setState({ navegationTreeList: [x] }, () => {
        if (value) {
          this.onChangeTree({value: value})
        }
      });
    }
  }

  onChangeTree = (e) => {
    console.log('[0]', e)
    const { onChangeCategorie } = this.props;
    const { navegationTreeList } = this.state;
    this.setState({ selectedNavegationTree: e.value });
    const element = navegationTreeList[0];
    const findValue = this.searchTree(element, e.value);
    const fullLabel = this.getLabelComplete(findValue, findValue.label)
    this.setState({ selectedLabelNavegationTree: fullLabel });
    onChangeCategorie({value: e.value, label: fullLabel, rest: findValue})
    this.onHideModal()
  };

  searchTree = (element, matchingTitle) => {
    if (element.key === matchingTitle) {
      return element;
    }
    if (element.children != null) {
      let i;
      let result = null;
      for (i = 0; result == null && i < element.children.length; i += 1) {
        result = this.searchTree(element.children[i], matchingTitle);
      }
      return result;
    }
    return null;
  };

  getLabelComplete = (findValue, string) => {
    const { navegationTreeList } = this.state;
    let newString = string
    if (findValue?.parentKey) {
      const findValueP = this.searchTree(navegationTreeList[0], findValue.parentKey);
      if (findValueP?.parentKey) newString = `${findValueP.label}/${newString}`
      else newString = `${findValueP?.label}/${newString}`
      return this.getLabelComplete(findValueP, newString)
    }
    return newString
  }

  filterByCategory = () => {
    const { t } = this.props
    const { navegationTreeList, selectedNavegationTree } = this.state;
    const children = (
      <div className="p-mt-2">
        <Tree
          value={navegationTreeList}
          selectionMode="single"
          selectionKeys={selectedNavegationTree}
          onSelectionChange={this.onChangeTree}
          filter
          filterMode="lenient"
        />
      </div>
    );
    this.setState({
      showModal: {
        isVisible: true,
        title: t('Árbol de navegación'),
        textOk: null,
        textHide: t('Cerrar'),
        actionOk: null,
        actionHide: () => this.onHideModal(),
        children,
      },
    });
  };

  onHideModal = () => {
    this.setState({
      showModal: {
        isVisible: false,
        actionHide: () => {},
      },
    });
  };

  render() {
    const {
      showModal,
      selectedLabelNavegationTree,
    } = this.state;
    
    const { t } = this.props

    const footerModal = (
      <div>
        {showModal.actionHide && (
          <Button label={showModal.textHide} onClick={showModal.actionHide} />
        )}
        {showModal.actionOk && (
          <Button label={showModal.textOk} onClick={showModal.actionOk} />
        )}
      </div>
    );

    return (
      <>
        <Button
          type="button"
          label={
            selectedLabelNavegationTree
              ? `${selectedLabelNavegationTree}`
              : t('Seleccione sección')
          }
          className="p-button-text"
          onClick={() => this.filterByCategory()}
        />
        <Dialog
          header={showModal.title}
          visible={showModal.isVisible}
          breakpoints={{'960px': '90vw'}}
          style={{ width: '35vw' }}
          footer={footerModal}
          onHide={showModal.actionHide}
        >
          {showModal.children}
        </Dialog>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  categoriesSectionCatalog: state.catalogs.sectionTreeCurrentCatalog,
  allowedSecciones: state.sessionPermission.secciones,
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, null)
  )(CategorieSectionDocumentTree);
